import { Component, computed, inject } from '@angular/core';
import { IWizardStepComponent } from '@mwe/models';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { OccupiedContractPartnerComponent } from './occupied/occupied_contract_partner.component';
import { EmptyContractPartnerComponent } from './empty/empty_contract_partner.component';
import { checkPrevDataAvailable, closeIfInactive } from '../meter-point-change-request.utils';
import { MeterPointChangeType } from '../meterpoint-change-request.types';
import { MeterPointChangeSignalState } from '../meterpoint-change-request.types';
import { SignalState } from '@shared-ikp/service/signal-state-service/signal-state.service';
import { convertEmptyFormToModel, convertOccupiedFormToModel } from './current-contract-partner-form-converter';
import { Router } from '@angular/router';
import { ROUTE_METER_POINT_CHANGE_REQUEST, ROUTE_PRODUCTS_AND_DATE } from '../../../app.constants';

@Component({
  selector: 'ikp-current-contract-partner',
  standalone: true,
  templateUrl: './current_contract_partner.component.html',
  imports: [OccupiedContractPartnerComponent, ReactiveFormsModule, EmptyContractPartnerComponent],
})
export class CurrentContractPartnerComponent implements IWizardStepComponent {
  protected wizardStore: MeterPointChangeSignalState = inject(SignalState);

  router = inject(Router);
  formBuilder = inject(FormBuilder);
  form = this.formBuilder.group({}, { validators: [] });
  selectedChangeType = computed(() => this.wizardStore.state().stepChangeType);
  hasPrevStepData = computed(
    () => this.wizardStore.state().productAndDate.meterPoints.length > 0 && this.wizardStore.state().meterPoint !== null,
  );

  hasAllNeededData(): boolean {
    closeIfInactive(this.wizardStore.state(), this.router);
    checkPrevDataAvailable(this.hasPrevStepData(), this.router, [ROUTE_METER_POINT_CHANGE_REQUEST, ROUTE_PRODUCTS_AND_DATE]);
    return true;
  }

  submit(): Promise<void> {
    if (this.isOccupiedChangeType()) {
      const occupiedContractPartner = convertOccupiedFormToModel(this.form);
      this.wizardStore.patchState({
        currentContractPartner: {
          occupiedContractPartner: occupiedContractPartner,
          emptyContractPartner: null,
        },
      });
    }
    if (this.selectedChangeType() === MeterPointChangeType.EMPTY_TO_OCCUPIED) {
      const emptyContractPartner = convertEmptyFormToModel(this.form);
      this.wizardStore.patchState({
        currentContractPartner: {
          emptyContractPartner: emptyContractPartner,
          occupiedContractPartner: null,
        },
      });
    }

    return Promise.resolve();
  }

  validate(): boolean {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
    return this.form?.valid;
  }

  protected readonly MeterPointChangeType = MeterPointChangeType;

  private isOccupiedChangeType() {
    return (
      this.selectedChangeType() === MeterPointChangeType.OCCUPIED_TO_EMPTY ||
      this.selectedChangeType() === MeterPointChangeType.TENANT_CHANGE
    );
  }
}
